import { ComponentProps, forwardRef, memo, PropsWithChildren } from 'react'
import { Popover } from 'devextreme-react'

export type CrewPopoverProps = PropsWithChildren<ComponentProps<typeof Popover>>

export const CrewPopover = memo(
  forwardRef<Popover, CrewPopoverProps>(({ children, ...rest }, ref) => (
    <Popover ref={ref} {...rest}>
      {children}
    </Popover>
  ))
)
